import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

const pad = (n) => String(n).padStart(2, "0");
const iso = (d) => `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;

export function presetRange(key) {
  const now = new Date();
  const y = now.getFullYear();
  const m = now.getMonth();
  if (key === "month") return { from: iso(new Date(y, m, 1)), to: iso(new Date(y, m + 1, 0)) };
  if (key === "prev_month") return { from: iso(new Date(y, m - 1, 1)), to: iso(new Date(y, m, 0)) };
  if (key === "quarter") {
    const qs = Math.floor(m / 3) * 3;
    return { from: iso(new Date(y, qs, 1)), to: iso(new Date(y, qs + 3, 0)) };
  }
  if (key === "year") return { from: iso(new Date(y, 0, 1)), to: iso(new Date(y, 11, 31)) };
  if (key === "half_year") return { from: iso(new Date(y, m - 5, 1)), to: iso(new Date(y, m + 1, 0)) };
  return { from: iso(new Date(y, m, 1)), to: iso(new Date(y, m + 1, 0)) };
}

const PRESETS = [
  { key: "month", label: "Этот месяц" },
  { key: "prev_month", label: "Прошлый месяц" },
  { key: "quarter", label: "Квартал" },
  { key: "half_year", label: "6 месяцев" },
  { key: "year", label: "Год" },
];

export default function PeriodPicker({ range, onChange }) {
  return (
    <div className="flex flex-wrap items-center gap-2" data-testid="period-picker">
      {PRESETS.map((p) => (
        <Button
          key={p.key}
          size="sm"
          variant={range.preset === p.key ? "default" : "outline"}
          data-testid={`period-${p.key}`}
          onClick={() => onChange({ ...presetRange(p.key), preset: p.key })}
        >
          {p.label}
        </Button>
      ))}
      <div className="flex items-center gap-2">
        <Input
          type="date"
          value={range.from}
          data-testid="period-from"
          className="h-9 w-[150px]"
          onChange={(e) => onChange({ ...range, from: e.target.value, preset: "custom" })}
        />
        <span className="text-muted-foreground">—</span>
        <Input
          type="date"
          value={range.to}
          data-testid="period-to"
          className="h-9 w-[150px]"
          onChange={(e) => onChange({ ...range, to: e.target.value, preset: "custom" })}
        />
      </div>
    </div>
  );
}
